@if (question?.question_prompt) {
  <app-highlight-message
    variant="info"
    icon="info"
    [message]="question?.question_prompt">
  </app-highlight-message>
}
